import { Instagram, Youtube, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-zinc-800 bg-[#0A0A0A]">
      <div className="mx-auto max-w-[1600px] px-6 pb-10 pt-20 md:px-12">
        <div className="flex flex-col justify-between gap-12 md:flex-row md:items-end">
          <div>
            <p data-testid="footer-wordmark" className="text-outline select-none font-display text-[clamp(4rem,14vw,14rem)] font-bold uppercase leading-[0.8] tracking-tight">
              CHWA
            </p>
          </div>
          <div className="space-y-6 md:text-right">
            <div className="flex gap-5 md:justify-end">
              <a data-testid="footer-social-instagram" href="https://instagram.com/chwasupply" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-zinc-500 transition-colors duration-300 hover:text-zinc-50">
                <Instagram size={20} />
              </a>
              <a data-testid="footer-social-youtube" href="https://youtube.com/@chwasupply" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-zinc-500 transition-colors duration-300 hover:text-zinc-50">
                <Youtube size={20} />
              </a>
              <a data-testid="footer-social-x" href="https://x.com/chwasupply" target="_blank" rel="noopener noreferrer" aria-label="X" className="text-zinc-500 transition-colors duration-300 hover:text-zinc-50">
                <Twitter size={20} />
              </a>
            </div>
            <div className="space-y-1 text-sm text-zinc-400">
              <p>
                <a data-testid="footer-email" href="mailto:hello@chwasupply.com" className="transition-colors duration-300 hover:text-zinc-50">
                  hello@chwasupply.com
                </a>
              </p>
              <p>
                <a data-testid="footer-website" href="https://chwasupply.com" target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-zinc-50">
                  chwasupply.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-3 border-t border-zinc-800 pt-6 text-[11px] uppercase tracking-[0.25em] text-zinc-600 md:flex-row">
          <p data-testid="footer-copyright">© 2026 CHWA Supply Co. — Texas, USA</p>
          <p data-testid="footer-tagline">Built for Work.</p>
        </div>
      </div>
    </footer>
  );
}
